import axios from 'axios';
import Slick from 'vue-slick';
import ProductItem from './product-item';
import { productQuery, transformGraphqlProduct } from './../utils/data';
import { storefrontRequestConfig } from '../utils/api';

export default {
    components: {
        Slick,
        ProductItem
    },
    props: {
        sortBy: {
            type: String
        },
        collectionHandle: {
            type: String
        }
    },

    data() {
        return {
            products: [],
            slickOptions: {
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: false,
                sortQueryString: '',
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1290,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            infinite: true,
                            centerMode: true,
                            centerPadding: '30px',
                            slidesToShow: 1,
                            arrows: true,
                            dots: false,
                            prevArrow: '.exclusive-products__mobile-arrows--previous',
                            nextArrow: '.exclusive-products__mobile-arrows--next',
                            
                        }
                    }
                ]
            }
        }
    },

    created() {
        // this._setSortKey()
        this._getProducts();
    },

    methods: {
        _getProducts(lastCursor=null) {
            this.isLoading = true;

            let args = `first: 250, sortKey: BEST_SELLING, reverse: false`;
            if (lastCursor) {
                args += `, after: "${ lastCursor }"`;
            }

            let data;
            if (this.collectionHandle == 'all') {
                data = `{
                    products(${ args }) {
                        edges {
                            node {
                                ${ productQuery }
                            }
                            cursor
                        }
                        pageInfo {
                            hasNextPage
                        }
                    }
                }`;
            } else {
                data = `{
                    collectionByHandle(handle: "${ this.collectionHandle }") {
                        id
                        description
                        products(${ args }) {
                            edges {
                                node {
                                    ${ productQuery }
                                }
                                cursor
                            }
                            pageInfo {
                                hasNextPage
                            }
                        }
                    }
                }`;
            }


            axios.post(`//${Shopify.shop}/api/2022-10/graphql.json`, data, storefrontRequestConfig).then(response => {
                const products = this.collectionHandle == 'all' ? response.data.data.products : response.data.data.collectionByHandle.products;

                this.products = [...this.products, ...products.edges.map(product => transformGraphqlProduct(product.node, this.collectionHandle))]

                // this.products = data;

            }).catch((error) => {
                console.log(error);
                this.isLoading = false;
            });
        },

        _setSortKey() {
            const { sortKey, reverse } = setSortKey(this.sortBy)

            this.sortQueryString = '&sort=' + sortKey + '&dir=' + reverse;
        }
    },
};